import React from 'react';
import TitleTag from '@/components/titletag';
import Bar from '@/components/charts/bar';
import MapChart from '@/components/charts/map';
import Chart from '@/business-components/chart';
import Pie from '@/components/charts/pie';
import styles from './index.module.scss';

export default function Recorded({ brandIndustryData, financeData, cityData }) {
  return (
    <Chart title="已收录品牌" dateSubTitle={false} panelClassName={styles.recorded}>
      <TitleTag style={{ marginTop: '20px' }}>行业分布</TitleTag>
      <Bar
        height={200}
        data={brandIndustryData}
        xField="industryTrackName"
        yField="percentage"
        yLabel=".00%"
        padding={[0, 60, 0, 70]}
        tooltipName={'行业占比'}
        label={[
          'percentage',
          xValue => {
            return {
              content: xValue + '.00%',
            };
          },
        ]}
      />
      <TitleTag style={{ marginTop: '20px' }}>地域分布</TitleTag>
      <MapChart data={cityData} tooltipName="品牌数量" height={264} showPercent={true} />
      <TitleTag style={{ marginTop: '20px' }}>融资分布</TitleTag>
      <Pie data={financeData} xField="financeRoundsValue" yField="financeRoundsName" unit={'.00%'} />
    </Chart>
  );
}
